/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { inventoryMarkInvoiced } from '../../axios/inventoryMarkInvoiced'
import type {
	InventoryMarkInvoicedError,
	InventoryMarkInvoicedPathParams,
	InventoryMarkInvoicedRequest,
	InventoryMarkInvoicedResponse,
} from '../../types/InventoryMarkInvoiced'

export const inventoryMarkInvoicedMutationKey = () => [{ url: '/:organisation/inventory/:item/invoiced' }] as const

export type InventoryMarkInvoicedMutationKey = ReturnType<typeof inventoryMarkInvoicedMutationKey>

export type InventoryMarkInvoicedVariables = {
	organisation: InventoryMarkInvoicedPathParams['organisation']
	item: InventoryMarkInvoicedPathParams['item']
	data: InventoryMarkInvoicedRequest
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InventoryController.php InventoryController::markInvoiced */
export function useInventoryMarkInvoiced<TContext = unknown>(
	options?: UseMutationOptions<
		InventoryMarkInvoicedResponse,
		AxiosError<InventoryMarkInvoicedError>,
		InventoryMarkInvoicedVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: inventoryMarkInvoicedMutationKey(),
		mutationFn: ({ organisation, item, data }: InventoryMarkInvoicedVariables) =>
			inventoryMarkInvoiced(organisation, item, data, config).then(res => res.data),
		...options,
	})
}
